
import React from 'react';
import { Message } from '@/types/message';
import ThreadGroup from './ThreadGroup';

interface ThreadTimelineProps {
  groupedThreads: Array<{
    threadId: string;
    messages: Message[];
    latestMessage: Message;
    timestamp: Date;
    hasMultipleVersions: boolean;
  }>;
  companyName: string;
  onRegenerateAIResponse?: (messageId: string, tone: string, customInstructions?: string) => Promise<Message | null>;
  isRegenerating?: boolean;
  regeneratingMessageId?: string;
  orderNumber?: string;
  userEmail?: string;
  sellerEmail?: string;
  latestAIMessage?: Message;
  expandedThreads: Record<string, boolean>;
  toggleThread: (threadId: string) => void;
}

const ThreadTimeline = ({
  groupedThreads,
  companyName,
  onRegenerateAIResponse,
  isRegenerating,
  regeneratingMessageId,
  orderNumber,
  userEmail,
  sellerEmail,
  latestAIMessage,
  expandedThreads,
  toggleThread
}: ThreadTimelineProps) => {
  return (
    <div className="relative space-y-5">
      {/* Add a visual timeline for message threads */}
      <div className="absolute left-4 top-0 bottom-0 w-[1px] bg-muted z-0 hidden md:block" />
      
      {groupedThreads.map((thread, threadIndex) => {
        const isLatestThread = threadIndex === groupedThreads.length - 1;
        
        return (
          <ThreadGroup
            key={thread.threadId}
            thread={thread}
            isLatestThread={isLatestThread}
            companyName={companyName}
            onRegenerateAIResponse={onRegenerateAIResponse}
            isRegenerating={isRegenerating}
            regeneratingMessageId={regeneratingMessageId}
            orderNumber={orderNumber}
            userEmail={userEmail}
            sellerEmail={sellerEmail}
            latestAIMessage={latestAIMessage}
            expandedThreads={expandedThreads}
            toggleThread={toggleThread}
          />
        );
      })}
    </div>
  );
};

export default ThreadTimeline;
